import { render, staticRenderFns } from "./productOperation.vue?vue&type=template&id=b8950c5c&"
import script from "./productOperation.vue?vue&type=script&lang=js&"
export * from "./productOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports